export default {
    common: {
        home: 'Home',
        zhen: '中文',
        user: 'Participants',
        userList: 'Participant list',
        personCenter: 'User Profile',
        meeting: 'Meetings',
        paper: 'Papers',
        Papers: 'Paper list',
        setInfo: 'Settings',
        signOut: 'Sign Out',
        signIn: 'Login',
        signUp: 'Sign up',
        //个人中心
        personCenterInfo:'User info',
        personCenterManager:'Account',
        personCenterLogs:'Logs',
        //会议管理
        meetManager:'Conferences',
        paperManager:'Paper list',
        paperReviewManager:'Review List',

        //论文管理 搜索框
        language:'Language',
        country:'Countries/Regions',
        DoubleCommit:'Double Submit',
        isEnabled:'Valid',
        evaluationResult:'ReviewResult',
        topic:'Topics',
        forum:'Please choose a forum',
        forum2:'Forum',
        Keywords:'Keywords',
        batch:'Batch processing',
        ChoseBatch:'Choose',
        DownLoadXlsx:'Download the paper list (.xlsx)',
        DownLoadxZip:'Download the paper package file (.zip)',
        commitPaper:'Submit paper',
        all:'All',
        ChinaWen:'Chinese',
        EnglishWen:'English',
        Yes:'Yes',
        No:'No',
        HasEffect:'Valid',
        NoEffect:'Invalid',
        evaluationResult1:'Accepted',
        evaluationResult2:'Undecided',
        evaluationResult3:'Rejected',
        docCode:'Paper ID',
        title:'Title',
        authorCode:'Author',
        jigou:'Institution',
        Abstract:'Abstract',
        sortType:'sortType',
        time_desc:'Descending time',
        time:'Time',
        doc_desc:'Descending paper ID',
        doc:'Paper ID',
        evaluationResult_desc:'Accept <Pending <Reject',
        evaluationResultSort:'Accept>Pending>Reject',
        finalScore_desc:'Descending Final Score',
        finalScore:'Final Score',
        sort:'Sort',
        search:'Search',
        reset:'Reset',

        //论文管理 表格
        allPaper:'All papers',
        Tobeallocated:'Tobeallocated',
        Tobereviewed:'',
        Reviewed:'Reviewed',

        authorInfo:'Author',
        reviewerMan:'Reviewer',
        reviewerInfo:'Reviewer Info',
        toSee:'View',
        grade:'Score',
        reviewerResult:'Review results',
        handle:'Edit',
        pleaseReviewer:'pleaseReviewer',

        manageReviewerMan:'anageReviewerMan',
        downLoad:'Download',
        toToReviewer:'Review',
        livePaper:'livePaper',
        notLivePaper:'notLivePaper',
        edit:'Edit',

        //注册登录相关
        CommonUser:'User',
        ManageUser:'Managers',
        forgetPass:'Forget password',
        rememberPass:'Remember password',
        autoPass:'Auto Login',
        password:'Password',
        phone:'Phone',
        pleaseInputAccount:'Please enter your account',
        pleaseInputPass:'Please enter your passwords with 6-18 digits',
        pleaseInputPhone:'Please enter phone number',
        pleaseInputVerificationCode:'Please enter verification code',
        getPhoneVerificationCode:'Get verification code',
        sendAgain:' sendAgain',
        NotNull:'It can not be null',
        pleaseInputRightPhone:'please input right phone',

        pleaseInputEmail:'please input email',
        email:'E-Mail',
        getEmailVerificationCode:'Get verification code',
        passwordAgain:'Confirm password',
        register:'register',
        enterpassword:'Please enter password',
        passIsNotSame:'pass is not same',

        //论文相关
        editPaper:'editPaper',
        paperTitle:'Title',
        pleaseInputPaperTitle:'title',
        paperAuthorList:'Authors',
        paperContactList:'Corresponding author',
        registerAndInvitation:'Registration Invitation',
        noUser: 'No account matched',
        createNewUser:'please create new account',
        searchAddUser:'Search and add authors',
        bindingEmail:'E-mail',
        bindingPhone:'Phone number',
        name:'Name',
        uploadFile:'Attachment upload',
        choseFile:'Upload a file',
        Createnow:'Submit',
        pleaseInputKeyWords:'keywords',
        pleaseInput:' ',
        pleaseChose:'topic',
        pleaseDoubleSubmit: 'Journal',
        confirmEdit:'Submit',
        cancel:'Cancel',
        delete:'delete',
        tip:'Tips',
        isConfirmdelete:'is confirm delete？',
        submitTip:'The last version will be overwritten after submission, and you need to submit your final revision before deadline.',
        //搜索用户
        searchUser:'searchUser',
        account:'Account Name',
        registerEmail:'Email',
        registerPhone:'Phone',
        pleaseInputValue:' ',
        add:'add',
        //创建用户
        createUser:'Create new account',
        contactEmail:'E-mail',
        contactPhone:'Phone number',
        role:'Role',
        cancelSpace:'Cancel',
        createSpace:'Create',
        index:'Order',

        //找回密码
        findBackPass:'find Back Pass',
        accountVerification:'Verify your account',
        complete:'complete',

        //论文详情页面
        paperDetail:'Details',
        paperInfo:'Status',
        reviewing:'Reviewing',
        Endofreview:'Review is completed',
        file:'file',
        preview:'Preview',
        reviewComments:'Add Comments',
        noData:'Null',
        commitReview:'Submit',
        back:'Back',
        Scoring:'scoring',
        inputReviewComments:'Please enter your comments',
        currentMeeting:'Current Conference',
        fullMsg:"Edit information",
        sex:"Gender",
        Male:"Male",
        Female:"Female",
        otherEmail:"Other E-mail",
        otherPhone:"Other phone Number",
        isWill:"Would you like to serve as a discussant?",
        research:"Research interest",
        remark:"Remarks",
        changeUserIcon:"Change profile picture",
        welcomeMag:"Welcome to the Conference Management System",
        goMeet:"Enter the conference website",
        AccountInfo:"Account info",
        changePass:"Change password",
        chnagePhone:"Change phone number",
        chnageEmail:"Change E-mail",
        choleRole:"Choose your role",
        resetPass:"Reset password",
        fineshed:"Finished",
        Next:"Next",
        help:"Help",
        meetingPeo:"User",
        clickUrl:"Click the link and view more details",
        wechatShare:"Scan and share on WeChat",
        WeChat:"WeChat",
        copyShare:"Copy and Share",
        manageSubject:"Conference",
        shareInMsg:"We invite you to register the Conference",
        oldPass:"Old password",
        newPass:"New password",
        enterNewAg:"Enter new password again",
        trueText:"Confirm",
        Organizer:"Organizer",
        Advisor:"Advisor",
        bindAccount:"Connect your account with E-mail or phone",
        msg1:"Your must have your account connected with E-mail or phone, please select ",
        msg2:"If you need to add connecting method later, please operate in User profile",
        gologin:"Login",
        labelTime:"Time",
        Region:"Region",
        other:"other",
        shareEmail:"Share the meeting with others",
        accountTip:'Please enter email or phone number as account name',
        copySuccessfully:'Copy successfully',
        addMeet:"Add a conference",
        upSort:"Sort by updated",
        pleaseSelects:"Please select",
        addRepeatly:"Add repeatly",
        selectPapers:"Please select papers",
        selectUsers:"Please select accounts",
        viewMsg:"All comments",
        emailTip:'Please enter your E-mail address to receive the review results.',
        organizer:'Organizer',
        location:'Location',
        more:'More',
    },
    front: {
        startCompany:'Founding Organizer',
        importantDate:'Important Dates',
        meetIntroduce:'Conference Introduction',
        meetSchedule:'Conference Program',
        meetOther:'Paper Submission',
        submit: 'Submit',
        goPc: 'Please go to the browser on the pc!'
    },
    msg:{
        msg01:'The list information will be used for paper information query, please fill in accurately. After adding, all authors can view and modify this paper.',
        fileMsg:'Support PDF format, the maximum file size is 100MB.',
        keyWordsMsg:'Keywords(separate with a semicolon)',
        createUserMsg01:'1) Please fill in the "contact email and mobile phone number" of TA correctly. After successful creation, the system will send the information of "invite TA to bind account"',
        createUserMsg02:'2) You can log in to modify the password',
        rightPhone:"Please enter correct phone number",
        smsSuccess:"SMS verification code has been sent",
        enterName:"Please enter your name",
        enterLength:"Between 2-300 characters",
        choseSex:"Please select gender",
        enterIns:"Please enter your institution",
        enterPaper:"Please enter the paper's title",
        enterLength2:"Between 3-300 characters",
        addAuthors:"Add more authors",
        enterabstrat:"Please enter the abstrat",
        enterkeywords:"Please enter the keywords",
        entertopics:"Please select the topic",
        tryAgain:"The operation is failed, please try again later",
        successMsg:"Success!",
        emailCodeSuccess:"The verification code has been sent to your Email",
        rightEmail:"Please enter correct Email",
        singSuccess:"Sign up successfully",
        pleaseUpload:"Please upload a file",
        addPeople:"Please add the corresponding author",
        copySuccess:"Copy successfully",
        onlyfile:"Please delete the old draft and upload a new draft.",
        noChangeTips:"Please note the it cannot be withdrawn after submission. Submit now?"
    }
}
